/* ============================================================
   JUSTYOL — cart drawer AOV ladder, "complete your order" rail,
   COD checkout modal (+ thanks state).
   Depends on Hyper theme globals: FoxTheme.routes, FoxTheme.utils,
   FoxTheme.pubsub, window.JY_AOV, window.JY_WA.
   All user-facing strings come from Liquid (data-* / JSON script).
   ============================================================ */
(function () {
  'use strict';
  if (window.__JYCart) return;
  window.__JYCart = true;

  var AOV = window.JY_AOV || { freeShip: 299, giftAt: 449, fee: 29 };

  /* ---------------- helpers ---------------- */
  /* Whole-dirham formatting to match the rest of the site (no ".00"). The
     store money_format / FoxTheme.formatMoney render decimals, which looked
     inconsistent against the PDP/cards, so we round to integer dirhams. */
  function formatMoney(cents, fallbackCurrency) {
    var n = Math.round((parseInt(cents, 10) || 0) / 100);
    return n.toLocaleString('fr-FR') + ' ' + (fallbackCurrency || 'Dhs');
  }

  function fetchCart() {
    return fetch(FoxTheme.routes.cart_url, Object.assign({}, FoxTheme.utils.fetchConfig())).then(function (r) {
      return r.json();
    });
  }

  function groupedSections() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
    );
    return sections;
  }

  function publishCartUpdate(cartJson) {
    if (window.FoxTheme && FoxTheme.pubsub) {
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
    }
  }

  /* Add a variant to the cart silently (drawer stays open, body re-renders). */
  function silentAdd(variantId, properties) {
    var body = {
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: groupedSections(),
      sections_url: window.location.pathname,
    };
    if (properties) body.items[0].properties = properties;

    return fetch(FoxTheme.routes.cart_add_url, Object.assign({}, FoxTheme.utils.fetchConfig(), { body: JSON.stringify(body) }))
      .then(function (r) {
        return r.json();
      })
      .then(function (parsed) {
        if (parsed.status && parsed.status !== 200) throw new Error(parsed.description || 'add failed');
        return fetchCart().then(function (cartJson) {
          cartJson['sections'] = parsed['sections'];
          publishCartUpdate(cartJson);
          return cartJson;
        });
      });
  }

  /* ---------------- AOV ladder ---------------- */
  function updateLadder(totalCents) {
    document.querySelectorAll('[data-jy-ladder]').forEach(function (ladder) {
      if (typeof totalCents !== 'number') {
        totalCents = Number(ladder.getAttribute('data-total')) || 0;
      }
      ladder.setAttribute('data-total', totalCents);

      var freeC = AOV.freeShip * 100;
      var giftC = AOV.giftAt * 100;
      var cur = ladder.getAttribute('data-currency') || 'Dhs';
      var pct = Math.min(100, (totalCents / giftC) * 100);
      var hasShip = totalCents >= freeC;
      var hasGift = totalCents >= giftC;

      var fill = ladder.querySelector('[data-jy-ladder-fill]');
      if (fill) fill.style.width = pct + '%';

      var markShip = ladder.querySelector('[data-jy-mark-ship]');
      var markGift = ladder.querySelector('[data-jy-mark-gift]');
      if (markShip) markShip.classList.toggle('hit', hasShip);
      if (markGift) markGift.classList.toggle('hit', hasGift);

      var msg = ladder.querySelector('[data-jy-ladder-msg]');
      if (msg) {
        var tpl, amount;
        if (hasGift) {
          tpl = ladder.getAttribute('data-msg-done') || '';
          amount = 0;
        } else if (hasShip) {
          tpl = ladder.getAttribute('data-msg-gift') || '';
          amount = Math.ceil((giftC - totalCents) / 100);
        } else {
          tpl = ladder.getAttribute('data-msg-ship') || '';
          amount = Math.ceil((freeC - totalCents) / 100);
        }
        msg.textContent = tpl.replace('[AMT]', amount + ' ' + cur);
      }
    });
  }

  /* ---------------- recommendations rail ---------------- */
  function loadRails() {
    document.querySelectorAll('[data-jy-crail]').forEach(function (rail) {
      if (rail.getAttribute('data-loaded') === 'true') return;
      var url = rail.getAttribute('data-url');
      if (!url) return;
      rail.setAttribute('data-loaded', 'true');

      fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error('network');
          return r.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-jy-crail-row]');
          var row = rail.querySelector('[data-jy-crail-row]');
          if (fresh && fresh.children.length && row) {
            row.innerHTML = fresh.innerHTML;
            rail.removeAttribute('hidden');
          } else {
            rail.setAttribute('hidden', '');
          }
        })
        .catch(function () {
          rail.setAttribute('hidden', '');
        });
    });
  }

  /* ---------------- COD modal ---------------- */
  var codModal = null;

  function CodModal(root) {
    this.root = root;
    this.scrim = root;
    this.form = root.querySelector('[data-jy-codm-form]');
    this.thanks = root.querySelector('[data-jy-codm-thanks]');
    this.itemsEl = root.querySelector('[data-jy-cod-items]');
    this.confirmBtn = root.querySelector('[data-jy-cod-submit]');
    this.confirmTotal = root.querySelector('[data-jy-cod-cta-total]');
    this.cart = null;
    this.bumpEl = null; /* active bump candidate */
    this.strings = {};
    this.config = { mode: 'checkout', currency: 'Dhs' };

    var dataEl = root.querySelector('[data-jy-cod-data]');
    if (dataEl) {
      try {
        var parsed = JSON.parse(dataEl.textContent);
        this.strings = parsed.strings || {};
        this.config = Object.assign(this.config, parsed.config || {});
      } catch (e) {
        /* noop */
      }
    }

    this.bindEvents();
  }

  CodModal.prototype.bindEvents = function () {
    var self = this;

    /* Tell dispatchers (PDP buy CTA) the modal handles this event so the
       cart-drawer fallback does not also open. */
    window.JY_COD_LISTENING = true;
    document.addEventListener('jy:cod:open', function (event) {
      if (event.cancelable) event.preventDefault();
      self.open((event.detail && event.detail.source) || 'unknown');
    });

    this.root.addEventListener('click', function (event) {
      if (event.target === self.scrim) self.close();
      if (event.target.closest('[data-jy-cod-close]')) self.close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !self.root.hidden) self.close();
    });

    /* bump toggle */
    this.root.querySelectorAll('[data-jy-bump-candidate] input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        cb.closest('.jy-bump').classList.toggle('on', cb.checked);
        self.renderTotals();
      });
    });

    /* live validation */
    this.root.querySelectorAll('[data-jy-cod-field]').forEach(function (field) {
      field.addEventListener('input', function () {
        field.classList.remove('jy-invalid');
        self.updateConfirmState();
      });
      field.addEventListener('change', function () {
        field.classList.remove('jy-invalid');
        self.updateConfirmState();
      });
    });

    if (this.confirmBtn) {
      this.confirmBtn.addEventListener('click', function (event) {
        event.preventDefault();
        self.submit();
      });
    }
  };

  CodModal.prototype.field = function (name) {
    return this.root.querySelector('[data-jy-cod-field="' + name + '"]');
  };

  CodModal.prototype.values = function () {
    return {
      name: (this.field('name') || {}).value || '',
      phone: (this.field('phone') || {}).value || '',
      city: (this.field('city') || {}).value || '',
      address: (this.field('address') || {}).value || '',
    };
  };

  CodModal.prototype.isValid = function () {
    var v = this.values();
    return v.name.trim().length > 1 && v.phone.replace(/\D/g, '').length >= 9 && v.city !== '';
  };

  CodModal.prototype.updateConfirmState = function () {
    if (!this.confirmBtn) return;
    this.confirmBtn.setAttribute('aria-disabled', this.isValid() ? 'false' : 'true');
  };

  CodModal.prototype.open = function (source) {
    var self = this;
    this.source = source;

    /* reset to form state */
    if (this.thanks) this.thanks.hidden = true;
    if (this.form) this.form.hidden = false;

    this.root.hidden = false;
    requestAnimationFrame(function () {
      self.root.classList.add('open');
    });
    document.body.classList.add('jy-modal-open');

    fetchCart().then(function (cart) {
      self.cart = cart;
      self.renderItems();
      self.pickBump();
      self.renderTotals();
      self.updateConfirmState();
    });
  };

  CodModal.prototype.close = function () {
    var self = this;
    this.root.classList.remove('open');
    document.body.classList.remove('jy-modal-open');
    setTimeout(function () {
      self.root.hidden = true;
    }, 200);
  };

  CodModal.prototype.renderItems = function () {
    if (!this.itemsEl || !this.cart) return;
    var self = this;
    var items = this.cart.items || [];
    var html = '';

    items.slice(0, 2).forEach(function (item) {
      var img = item.image
        ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120'
        : '';
      html +=
        '<div class="jy-codm__item">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '<div class="jy-codm__item-body">' +
        '<div class="jy-codm__item-title">' + escapeHtml(item.product_title || item.title || '') + '</div>' +
        '<div class="jy-codm__item-meta">' + escapeHtml(item.vendor || '') + ' · ×' + item.quantity + '</div>' +
        '<div class="jy-codm__item-price">' + formatMoney(item.final_line_price, self.config.currency) + '</div>' +
        '</div></div>';
    });

    if (items.length > 2) {
      html += '<div class="jy-codm__more">+' + (items.length - 2) + ' ' + escapeHtml(this.strings.moreItems || '') + '</div>';
    }

    this.itemsEl.innerHTML = html;
  };

  /* show first bump candidate whose product is not already in the cart */
  CodModal.prototype.pickBump = function () {
    var self = this;
    var inCart = {};
    ((this.cart && this.cart.items) || []).forEach(function (item) {
      inCart[String(item.product_id)] = true;
    });

    this.bumpEl = null;
    this.root.querySelectorAll('[data-jy-bump-candidate]').forEach(function (el) {
      var pid = el.getAttribute('data-product-id');
      var cb = el.querySelector('input[type="checkbox"]');
      if (!self.bumpEl && !inCart[pid]) {
        self.bumpEl = el;
        el.hidden = false;
      } else {
        el.hidden = true;
        if (cb) cb.checked = false;
        el.classList.remove('on');
      }
    });
  };

  CodModal.prototype.bumpChecked = function () {
    if (!this.bumpEl) return false;
    var cb = this.bumpEl.querySelector('input[type="checkbox"]');
    return !!(cb && cb.checked);
  };

  CodModal.prototype.computeTotals = function () {
    var sub = this.cart ? this.cart.total_price : 0;
    var bumpVal = this.bumpChecked() ? Number(this.bumpEl.getAttribute('data-bump-price')) || 0 : 0;
    var fee = sub + bumpVal >= AOV.freeShip * 100 ? 0 : AOV.fee * 100;
    return { sub: sub, bumpVal: bumpVal, fee: fee, grand: sub + bumpVal + fee };
  };

  CodModal.prototype.renderTotals = function () {
    var t = this.computeTotals();
    var cur = this.config.currency;
    var set = function (sel, val) {
      var el = this.root.querySelector(sel);
      if (el) el.innerHTML = val;
    }.bind(this);

    set('[data-jy-cod-sub]', formatMoney(t.sub, cur));
    set('[data-jy-cod-total]', formatMoney(t.grand, cur));
    if (this.confirmTotal) this.confirmTotal.textContent = formatMoney(t.grand, cur);

    var feeEl = this.root.querySelector('[data-jy-cod-fee]');
    if (feeEl) {
      if (t.fee === 0) {
        feeEl.innerHTML = '<span class="jy-free">' + escapeHtml(this.strings.free || '') + '</span>';
      } else {
        feeEl.innerHTML = formatMoney(t.fee, cur);
      }
    }

    var bumpRow = this.root.querySelector('[data-jy-cod-bump-row]');
    if (bumpRow) {
      bumpRow.hidden = t.bumpVal === 0;
      var bumpAmount = bumpRow.querySelector('[data-jy-cod-bump-amount]');
      if (bumpAmount) bumpAmount.textContent = formatMoney(t.bumpVal, cur);
      var bumpLabel = bumpRow.querySelector('[data-jy-cod-bump-label]');
      if (bumpLabel && this.bumpEl) {
        bumpLabel.textContent = '🔥 ' + (this.bumpEl.getAttribute('data-title') || '');
      }
    }
  };

  CodModal.prototype.markInvalidFields = function () {
    var v = this.values();
    if (v.name.trim().length <= 1) this.field('name') && this.field('name').classList.add('jy-invalid');
    if (v.phone.replace(/\D/g, '').length < 9) this.field('phone') && this.field('phone').classList.add('jy-invalid');
    if (v.city === '') this.field('city') && this.field('city').classList.add('jy-invalid');
  };

  CodModal.prototype.submit = function () {
    var self = this;
    if (!this.isValid()) {
      this.markInvalidFields();
      return;
    }
    if (this.confirmBtn.classList.contains('is-loading')) return;
    this.confirmBtn.classList.add('is-loading');

    var v = this.values();
    var totals = this.computeTotals();

    var addBump = this.bumpChecked()
      ? silentAdd(this.bumpEl.getAttribute('data-variant-id'), { _jy_bump: '1' }).catch(function () {})
      : Promise.resolve();

    addBump
      .then(function () {
        /* persist COD details as cart attributes (read by checkout / COD app) */
        var body = JSON.stringify({
          attributes: {
            jy_cod: '1',
            jy_cod_name: v.name.trim(),
            jy_cod_phone: v.phone.trim(),
            jy_cod_city: v.city,
            jy_cod_address: v.address.trim(),
            jy_cod_bump: self.bumpChecked() ? '1' : '',
          },
        });
        return fetch(FoxTheme.routes.cart_update_url, Object.assign({}, FoxTheme.utils.fetchConfig(), { body: body }));
      })
      .then(function () {
        if (self.config.mode === 'thanks') {
          self.showThanks(totals, v);
        } else {
          window.location.href = '/checkout';
        }
      })
      .catch(function () {
        /* network error: still try to reach checkout so the order isn't lost */
        if (self.config.mode !== 'thanks') window.location.href = '/checkout';
      })
      .finally(function () {
        self.confirmBtn.classList.remove('is-loading');
      });
  };

  CodModal.prototype.showThanks = function (totals, values) {
    if (!this.thanks) return;
    var ar = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
    var locale = ar ? 'ar-MA' : 'fr-FR';

    /* client-side reference only — the real order id comes from Shopify/COD app */
    var ref = 'JY-' + (10000 + Math.floor(Math.random() * 90000));

    var dateA = new Date();
    dateA.setDate(dateA.getDate() + 2);
    var dateB = new Date();
    dateB.setDate(dateB.getDate() + 4);
    var fmt = function (d) {
      try {
        return d.toLocaleDateString(locale, { day: 'numeric', month: 'short' });
      } catch (e) {
        return d.toLocaleDateString();
      }
    };

    var put = function (sel, val) {
      var el = this.thanks.querySelector(sel);
      if (el) el.textContent = val;
    }.bind(this);

    put('[data-jy-thanks-ref]', ref);
    put('[data-jy-thanks-total]', formatMoney(totals.grand, this.config.currency));
    put('[data-jy-thanks-eta]', fmt(dateA) + ' – ' + fmt(dateB));
    put('[data-jy-thanks-phone]', values.phone || '06 •• •• •• ••');

    this.form.hidden = true;
    this.thanks.hidden = false;
    this.root.querySelector('.jy-codm').scrollTop = 0;
  };

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  /* ---------------- wiring ---------------- */
  document.addEventListener('click', function (event) {
    /* rail mini-card "+" — add silently, drawer stays open */
    var addBtn = event.target.closest('[data-jy-add]');
    if (addBtn) {
      event.preventDefault();
      if (addBtn.classList.contains('is-loading')) return;
      addBtn.classList.add('is-loading');
      silentAdd(addBtn.getAttribute('data-variant-id'))
        .catch(function () {})
        .finally(function () {
          addBtn.classList.remove('is-loading');
        });
      return;
    }

    /* COD CTA → custom COD checkout page (EasySell modal dropped) */
    var codBtn = event.target.closest('[data-jy-cod-open]');
    if (codBtn) {
      event.preventDefault();
      var codCartUrl = ((window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url) || '/cart').replace(/\/+$/, '');
      window.location.href = codCartUrl + '?view=checkout';
    }
  });

  /* keep the cart-page sticky bar total in sync with partial re-renders —
     mirrors the Liquid math: under the free-ship threshold the estimated
     total includes the delivery fee (no +29 surprise on the next page) */
  function syncStickyBar(totalCents) {
    var el = document.querySelector('.jy-cart-stickybar__value');
    if (!el || typeof totalCents !== 'number') return;
    var grand = totalCents >= AOV.freeShip * 100 ? totalCents : totalCents + AOV.fee * 100;
    el.textContent = formatMoney(grand);
  }

  /* re-evaluate ladder + rail after every cart re-render */
  document.addEventListener('cart:updated', function (event) {
    var total = event.detail && event.detail.cart ? event.detail.cart.total_price : undefined;
    updateLadder(typeof total === 'number' ? total : undefined);
    syncStickyBar(total);
    loadRails();
  });

  /* cart:refresh re-renders the whole drawer asynchronously without
     dispatching cart:updated — re-init once the new markup is in place */
  document.addEventListener('cart:refresh', function () {
    setTimeout(function () {
      updateLadder();
      loadRails();
    }, 1000);
  });

  /* ---------------- remove → undo toast ---------------- */
  var jyUndoPending = null;
  var jyUndoTimer = null;

  function jyUndoToast(item) {
    var isAr = document.documentElement.lang && document.documentElement.lang.indexOf('ar') === 0;
    var el = document.getElementById('jy-undo-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'jy-undo-toast';
      el.className = 'jy-atc-toast jy-undo-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.innerHTML =
      '<span class="jy-atc-toast__body"><span class="jy-atc-toast__ok">' +
      (isAr ? 'تم حذف المنتج' : 'Article retiré') +
      '</span></span>' +
      '<button type="button" class="jy-atc-toast__cta" data-jy-undo>' +
      (isAr ? 'تراجع' : 'Annuler') +
      '</button>';
    void el.offsetWidth;
    el.classList.add('is-on');
    if (jyUndoTimer) clearTimeout(jyUndoTimer);
    jyUndoTimer = setTimeout(function () {
      el.classList.remove('is-on');
      jyUndoPending = null;
    }, 6000);

    el.querySelector('[data-jy-undo]').onclick = function () {
      el.classList.remove('is-on');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.id, quantity: item.qty }),
      })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          window.location.reload();
        });
    };
  }

  /* capture the item on remove-click (before the row is gone) */
  document.addEventListener(
    'click',
    function (event) {
      var rm = event.target.closest('[is="cart-remove-item"]');
      if (!rm) return;
      var row = rm.closest('.cart-item') || rm.closest('tr');
      var qtyInput = row && row.querySelector('[data-quantity-variant-id]');
      if (qtyInput) {
        jyUndoPending = {
          id: qtyInput.getAttribute('data-quantity-variant-id'),
          qty: parseInt(qtyInput.value, 10) || 1,
        };
      }
    },
    true
  );

  /* after the cart re-renders following a removal, offer undo (once) */
  document.addEventListener('cart:updated', function () {
    if (jyUndoPending && jyUndoPending.id) {
      var it = jyUndoPending;
      jyUndoPending = null;
      jyUndoToast(it);
    }
  });

  function init() {
    updateLadder();
    loadRails();
    /* COD modal disabled — native Shopify checkout is used instead. */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
